import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  TextField,
  Typography,
  Input,
} from "@mui/material";
import MainContainer from "../../layout/MainContainer";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import { ChangeEvent, useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  useAddCategoryMutation,
  useLazyGetCategoryByIdQuery,
  useUpdateCategoryMutation,
} from "../../services/categories";
import { Category } from "../../types/General";
import { Loader, showError, showToast } from "../../constants";
import { UploadMedia } from "../../utils/mediaUpload";
import { isString } from "../../utils/validations";
import useAuth from "../../hooks/useAuth";

const AddCategories = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [addCategory] = useAddCategoryMutation();
  const [updateCategory] = useUpdateCategoryMutation();
  const [getCategoryDetails, { isLoading }] = useLazyGetCategoryByIdQuery();
  const [image, setImage] = useState("");
  const [categoryData, setCategoryData] = useState<Category>();
  const [imageId, setImageId] = useState<any>(0);
  const [loading, setLoading] = useState(false);
  const userData = useAuth();
  const [hidePermission, setHidePermission] = useState<any>({
    is_add_edit: true,
    is_view: true,
    is_delete: true,
  });
  const permissions = userData?.role?.permissions;
  const permissions_name: string[] = [];

  if (permissions && permissions.length > 0) {
    permissions.forEach((permission: any) => {
      const moduleName = permission.module.name;
      permissions_name.push(moduleName);
    });
  }
  const checkPermission = () => {
    if (permissions_name?.length) {
      let idx = permissions_name.findIndex(
        (moduleName: string) => moduleName === "Manage Categories"
      );

      console.log("Index2333:", idx);

      if (idx !== -1) {
        const manageCategoryPermission = permissions[idx];
        console.log(manageCategoryPermission, "---393839--");
        if (
          manageCategoryPermission &&
          !manageCategoryPermission?.is_add_edit
        ) {
          showError("You dont't have the permission to add in Category page");
          navigate("/dashboard", { replace: true });
        }
        let data = {
          is_add_edit: permissions[idx]?.is_add_edit,
          is_delete: permissions[idx]?.is_delete,
        };
        setHidePermission(data);
        console.log("lsksjdisjs", hidePermission);
      }
    }
  };
  console.log("hide", hidePermission);
  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target;
    const file = files?.files?.length ? files?.files[0] : "";
    // Check if a file is selected
    if (file) {
      // Check if the selected file is an image
      if (file.type.startsWith("image/")) {
        const res = await UploadMedia(file);
        if (res?.code === 200) {
          setImage(res?.data[0]?.media_file_url);
          setImageId(res?.data[0]?.id);
        } else {
          showError(res?.message);
        }
      } else {
        // Display an error message for non-image files
        showError("Please select a valid image file (png or jpeg).");
      }
    }
  };

  const getCategoryDetail = async () => {
    try {
      const res = await getCategoryDetails({ categoryId: id }).unwrap();
      if (res?.code === 200) {
        setCategoryData(res?.data);
        setImage(res?.data?.category_image?.media_file_url);
        setImageId(res?.data?.category_image?.id);
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: categoryData?.category_name || "",
    },
    validationSchema: Yup.object({
      title: Yup.string()
        .required("This field is required")
        .max(25, "Maximum 25 character are allowed")
        .min(2, "Minimum 2 characters are required"),
    }),
    onSubmit: async () => {
      formik.setSubmitting(true);

      const body = {
        category_name: formik?.values?.title,
        category_image: imageId || null,
      };

      if (id && id !== "add") {
        setLoading(true);
        try {
          const response = await updateCategory({
            categoryId: id,
            body,
          }).unwrap();
          if (response?.code === 200) {
            setLoading(false);
            showToast("Category updated successfully");
            navigate("/manage-categories");
          } else {
            setLoading(false);
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "");
          console.log(error);
        }
      } else {
        setLoading(true);
        try {
          const response = await addCategory(body).unwrap();
          if (response?.code === 201) {
            setLoading(false);
            showToast("Category added successfully");
            formik.resetForm();
            navigate("/manage-categories");
          } else {
            setLoading(false);
            showError(response?.message || "");
          }
        } catch (error: any) {
          setLoading(false);
          showError(error?.data?.message || "");
          console.log(error);
        }
      }
    },
  });

  useEffect(() => {
    if (id) {
      getCategoryDetail();
    }
  }, []);
  useEffect(() => {
    if (userData && userData?.role?.permissions?.length) {
      checkPermission();
    }
  }, [userData]);
  return (
    <>
      <MainContainer>
        <Loader isLoad={isLoading || loading} />
        <div className="main_loyout">
          <div className="dashboard">
            <h1>Add Category</h1>
            <Loader isLoad={loading} />
            <Button
              className="btn btn_primary"
              onClick={() => {
                navigate("/manage-categories");
              }}
            >
              Back
            </Button>
          </div>
          <Card className="cards">
            <form onSubmit={formik.handleSubmit}>
              <CardContent sx={{ p: 1 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography className="custom_label">Image</Typography>
                    {image?.length > 0 ? (
                      <div className="upload_image_preview">
                        <CardMedia component="img" image={image} alt="photo" />
                        <CancelIcon
                          onClick={() => {
                            setImage("");
                            setImageId(null);
                          }}
                        />
                      </div>
                    ) : (
                      <Box className="upload_image">
                        <label htmlFor="icon-button-file">
                          <Input
                            sx={{ display: "none" }}
                            id="icon-button-file"
                            type="file"
                            inputProps={{
                              accept: "image/png,image/jpeg",
                            }}
                            onChange={handleImageUpload}
                          />
                          <Button component="span" className="upload_image_btn">
                            <img
                              src="/static/images/user_placeholder.png"
                              alt=""
                            />
                            <CameraAltIcon />
                          </Button>
                        </label>
                      </Box>
                    )}
                  </Grid>

                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Category Name
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      className="text_field"
                      name="title"
                      variant="outlined"
                      fullWidth
                      placeholder="Category Name"
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else if (isString(val.target.value)) {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.title}
                      helperText={formik.touched.title && formik.errors.title}
                    />
                  </Grid>
                </Grid>
                <div className="form_btn">
                  <Button
                    size="large"
                    type="submit"
                    className="btn btn_primary"
                  >
                    Save
                  </Button>
                </div>
              </CardContent>
            </form>
          </Card>
        </div>
      </MainContainer>
    </>
  );
};

export default AddCategories;
